
<footer class="footer">
  <div class="container">
    <div class="contact-us-heading">
      <span aria-label="Declaration">
        {{'copyrightText'|translate:translations}} &copy; Five Areas Ltd. {{'allrightsreservedText'|translate:translations}}.
      </span>
      <div class="navigation-links">
        <span><a href="/terms">{{'termsandconditionsText'|translate:translations}}</a>|</span>&nbsp;
        <span><a href="/privacy-policy">{{'privacyPolicyText'|translate:translations}}</a>|</span>&nbsp;
        <span><a href="/contact">{{'contactusText'|translate:translations}}</a></span>
      </div>
    </div>
    <div>
      <span class="app-version">
        Version: {{ applicationVersion }}
      </span>
    </div>
  </div>
</footer>


